import api from './api';

const TOKEN_KEY = 'golf_admin_token';
const ADMIN_KEY = 'golf_admin_user';

export const login = async (email, password) => {
  const response = await api.post('/admin/login', { email, password });
  const { access_token, admin } = response.data;
  localStorage.setItem(TOKEN_KEY, access_token);
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
  return { token: access_token, admin };
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isAuthenticated = () => {
  return !!getToken();
};
